import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EntityTypeEnum, WorkflowActions } from 'api'
import { useModal } from 'view/shared/modal'
import { TextButtonType, TextButton } from 'view/components/buttons'
import { EntityTypeIdRecord, NotificationType } from 'store/notification/notificationTypes'
import { Locale, Translation } from 'locale'
import { SectorMappingEditDialog } from '../SectorMappingDialog/SectorMappingEditDialog'
import styled from '@emotion/styled'
import { NotificationActions } from 'store/notification'
import { ProductSectorMappingActions } from 'api/ProductSectorMappingActions'
import { productSectorMappingHasChangesSelector } from 'selectors/productSelectors'

export const SectorMappingActionsWrapper = styled.div`
  width: 500px;
  margin-left: auto;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  height: 30px;
`

export const SectorMappingActions: React.FC = () => {
  const { showModal } = useModal()

  const dispatch = useDispatch()

  const onAddButtonClick = () => {
    const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
      showModal(
        <SectorMappingEditDialog
          workflowId={workflowId}
          entityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.PRODUCT_SECTOR_MAPPING_DRAFT]}
        />
      )
    }
    dispatch(WorkflowActions.createNewWorkflow(EntityTypeEnum.PRODUCT_SECTOR_MAPPING_DRAFT, correlatedResponseCallback))
  }

  const onCommitMappings = () => {
    dispatch(
      NotificationActions.showDialog({
        type: NotificationType.Confirm,
        titleText: Locale.translate(Translation.TC_SECTOR_DRAFT_MAPPINGS),
        messageText: Locale.translate(Translation.TC_SECTOR_COMMIT_MAPPINGS),
        buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
        defaultButton: Translation.TC_BUTTON_YES,
        cancelButton: Translation.TC_BUTTON_NO,
        responseMap: {
          [Translation.TC_BUTTON_YES]: [() => dispatch(ProductSectorMappingActions.commit())]
        }
      })
    )
  }

  const onDiscardMappings = () => {
    dispatch(
      NotificationActions.showDialog({
        type: NotificationType.Confirm,
        titleText: Locale.translate(Translation.TC_SECTOR_DRAFT_MAPPINGS),
        messageText: Locale.translate(Translation.TC_SECTOR_DISCARD_MAPPINGS),
        buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
        defaultButton: Translation.TC_BUTTON_YES,
        cancelButton: Translation.TC_BUTTON_NO,
        responseMap: {
          [Translation.TC_BUTTON_YES]: [() => dispatch(ProductSectorMappingActions.discard())]
        }
      })
    )
  }

  const onReportMappings = () => {
    dispatch(ProductSectorMappingActions.generateReport())
    dispatch(
      NotificationActions.showGrowl({
        type: NotificationType.Success,
        title: Translation.SC_REPORT_MAPPING_REQUESTED,
        message: Translation.SC_REPORT_MAPPING_REQUESTED
      })
    )
  }

  const hasChanges = useSelector(productSectorMappingHasChangesSelector)

  return (
    <SectorMappingActionsWrapper>
      <TextButton dataTestId={'SectorMappingToolbar-TextButton-ButtonNewSector'} type={TextButtonType.Primary} onClick={onAddButtonClick}>
        {Locale.translate(Translation.TC_BUTTON_NEW_SECTOR_MAPPING)}
      </TextButton>
      <TextButton
        dataTestId={'SectorMappingToolbar-TextButton-ButtonReportMappings'}
        type={TextButtonType.Primary}
        onClick={onReportMappings}>
        {Locale.translate(Translation.TC_BUTTON_MAPPINGS_REPORT)}
      </TextButton>
      <TextButton
        disabled={!hasChanges}
        dataTestId={'SectorMappingToolbar-TextButton-ButtonCommitMappings'}
        type={TextButtonType.Primary}
        onClick={onCommitMappings}>
        {Locale.translate(Translation.TC_BUTTON_COMMIT_MAPPINGS)}
      </TextButton>
      <TextButton
        disabled={!hasChanges}
        dataTestId={'SectorMappingToolbar-TextButton-ButtonDiscardMappings'}
        type={TextButtonType.Primary}
        onClick={onDiscardMappings}>
        {Locale.translate(Translation.TC_BUTTON_DISCARD_MAPPINGS)}
      </TextButton>
    </SectorMappingActionsWrapper>
  )
}
